import { render, staticRenderFns } from "./CreateThreat.vue?vue&type=template&id=cd0a3754&"
import script from "./CreateThreat.vue?vue&type=script&lang=js&"
export * from "./CreateThreat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports